import 'babel-polyfill';
import 'isomorphic-fetch';
import 'bootstrap';

import './Shared.scss';
import './Vendor.scss';
import './Banner/Banner.scss';

import './DirectionForm/DirectionForm';

import Header from './Header/Header';
import './Footer/Footer';

import './EmergencyNotification/EmergencyNotification';
import './Accessibility/Accessibility';

new Header().init();




// WEBPACK FOOTER //
// ./Src/Shared/Shared.js